<div class="maintenance-container show">
  <div class="maintenance-content p-4 text-center">
    @if (type === 'offline') {
      <div class="mb-3">
        <i class="fe fe-wifi-off text-danger" style="font-size: 3rem;"></i>
      </div>
      <h2 class="mb-2" style="font-weight: 600;">{{"connectez-vous à internet" | translate}}</h2>
      <p class="text-muted mb-4 px-5">{{"votre connexion internet semble être interrompue. veuillez vérifier votre connexion et réessayer." | translate}}</p>
    } @else {
      <div class="mb-3">
        <i class="fe fe-settings text-warning" style="font-size: 3rem;"></i>
      </div>
      <h2 class="mb-2" style="font-weight: 600;">{{"application en maintenance" | translate}}</h2>
      <p class="text-muted mb-4 px-5">{{"l'application est actuellement inaccessible pour maintenance. veuillez réessayer dans quelques instants." | translate}}</p>
    }
    
    <div class="d-flex justify-content-center">
      <button class="btn btn-primary px-5" (click)="reloadPage()">
        {{"réessayer" | translate}}
      </button>
    </div>
  </div>
</div>
